module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../images/index/topbanner.png"),
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._v("填写参保人信息")]), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('p', {
    staticClass: "label bb clearfix"
  }, [_c('label', {
    attrs: {
      "for": "user_name"
    }
  }, [_vm._v("姓名：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    attrs: {
      "type": "text",
      "id": "user_name",
      "maxlength": "15",
      "placeholder": "请输入真实姓名",
      "value": ""
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "focus": _vm.eidtName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "label bb clearfix"
  }, [_c('label', {
    attrs: {
      "for": "user_card"
    }
  }, [_vm._v("身份证号：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.card),
      expression: "formData.card"
    }],
    attrs: {
      "type": "text",
      "id": "user_card",
      "placeholder": "请输入身份证号",
      "maxlength": "18"
    },
    domProps: {
      "value": (_vm.formData.card)
    },
    on: {
      "focus": _vm.eidtCard,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "card", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "notice"
  }, [_vm._v("信息保护声明")]), _vm._v(" "), _c('div', {
    staticClass: "noticeInfo"
  }, [_vm._v("以上信息只供WiFi安全险登记及理赔用途，并不会用于其他商业用途。")])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('p', {
    staticClass: "protocol"
  }, [_c('span', {
    staticClass: "checkbox checked"
  }), _vm._v("本人同意并接受\n            "), (_vm.protocol == 'protocol') ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.clickProtocol(_vm.protocol)
      }
    }
  }, [_vm._v("《WiFi万能钥匙理赔服务协议》")]) : _vm._e(), _vm._v(" "), (_vm.protocol == 'protocolIos') ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.clickProtocol(_vm.protocol)
      }
    }
  }, [_vm._v("《WiFi万能钥匙理赔服务协议》")]) : _vm._e(), _vm._v(" "), (_vm.protocol == 'protocolIvvi') ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.clickProtocol(_vm.protocol)
      }
    }
  }, [_vm._v("《免费WiFi理赔服务协议》")]) : _vm._e(), _vm._v(" "), (_vm.protocol == 'protocolA0009') ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.clickProtocol(_vm.protocol)
      }
    }
  }, [_vm._v("《免费WiFi理赔服务协议》")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "errorMsg"
  }), _vm._v(" "), _c('p', {
    staticClass: "buttons"
  }, [_c('a', {
    staticClass: "button btn",
    on: {
      "click": _vm.create
    }
  }, [_vm._v("参保安心上网")])])]), _vm._v(" "), _c('qa', {
    attrs: {
      "type": 3
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright",
    staticStyle: {
      "padding-bottom": "12px"
    }
  }, [_vm._v("南京尚网网络科技有限公司对以上信息保留最终解释权")]), _vm._v(" "), (_vm.showAlertModel) ? _c('div', {
    staticClass: "alert-model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.modelContent))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("客服电话："), _c('a', {
    attrs: {
      "href": "tel:4000358000"
    }
  }, [_vm._v("4000358000")]), _c('span', {
    staticClass: "copy-qq",
    on: {
      "click": function($event) {
        return _vm.copyQq(4000358000)
      }
    }
  }, [_vm._v("复制")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "foot",
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("我知道了")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    staticStyle: {
      "display": "block"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "description"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tip.png")
    }
  }), _vm._v("如手机号码有更换，请联系官方客服")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30927b44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/create.vue
// module id = 819
// module chunks = 1